import ConnectionNotesList from './ConnectionNotesList';
import ConnectionDetails from './ConnectionDetails';

// @vue/component
export default {
  name: 'ConnectionDetailsAndNotes',

  components: {
    ConnectionNotesList,
    ConnectionDetails,
  },

  props: {
    connection: {
      type: Object,
      default: () => ({}),
    },
  },
};
